import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export class DimensionCarousel {

	el: HTMLElement
	swiper: Swiper
	nextEl: HTMLElement
	prevEl: HTMLElement
    
	constructor(el) {
		this.el = el.querySelector('.swiper')
    this.nextEl = el.querySelector('.swiper-custom-button-next')
    this.prevEl = el.querySelector('.swiper-custom-button-prev')
		this.init()
	}

	init() {
		this.swiper = new Swiper(this.el, {
			modules: [ Navigation ],
			speed: 500,
			slidesPerView: 1,
      spaceBetween: 24,
			allowTouchMove: true,
      breakpoints: {
        1024: {
          slidesPerView: 2,
          spaceBetween: 24
        }
      },
			navigation: {
				nextEl: this.nextEl,
				prevEl: this.prevEl,
			}
		})
	}
}